import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../../../supabase';
import { normalizeHomePreferences } from '../model/homePreferences';
import { enqueueHomeSave, homePreferencesKey, readHomeProfile, saveHomePreferences } from './homePreferencesApi';

export function useHomePreferences(userId) {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey:homePreferencesKey(userId),
    queryFn:() => readHomeProfile(supabase,userId),
    // AUD-05 P1: 60 s → 5 min. Kept apart from useAuthSetup's own-row read on purpose: the
    // saves write a 4-column row into THIS key, and that read feeds one-shot side effects.
    enabled:!!userId, staleTime:5*60*1000, retry:false, refetchOnWindowFocus:true,
  });
  const mutation = useMutation({
    mutationKey:homePreferencesKey(userId),
    mutationFn:({id,patch}) => enqueueHomeSave(id,() => saveHomePreferences(supabase,id,patch)),
    onSuccess:(profile,{id}) => queryClient.setQueryData(homePreferencesKey(id),profile),
  });
  return {
    home:normalizeHomePreferences(query.data?.preferences?.home),
    profile:query.data,
    isPending:query.isPending, isError:query.isError, error:query.error,
    refetch:query.refetch,
    save:patch => mutation.mutateAsync({id:userId,patch}),
    isSaving:mutation.isPending && mutation.variables?.id === userId,
    saveError:mutation.variables?.id === userId ? mutation.error : null,
  };
}
